import './Tabs.css';
export var tabsArrowButtonCSS = '_1tfbrxp6-3-8-0';
export var tabsArrowWrapperCSS = '_1tfbrxp5-3-8-0';
export var tabsCSS = '_1tfbrxp0-3-8-0';
export var tabsWrapperCSS = '_1tfbrxp1-3-8-0';
export var tabsWrapperOverflowCSS = {left:'_1tfbrxp2-3-8-0',right:'_1tfbrxp3-3-8-0',both:'_1tfbrxp4-3-8-0'};